// extracted by mini-css-extract-plugin
module.exports = {"header-navigation":"BasePageLayout_header-navigation__RDTD1","headerNavigation":"BasePageLayout_header-navigation__RDTD1"};